import { Component, OnInit } from '@angular/core';
import { AccountInfo } from '@azure/msal-browser';
import { AuthService } from '../auth/auth.service';

@Component({
	selector: 'rpfsa-user-info',
	templateUrl: './user-info.component.html',
	styleUrls: ['./user-info.component.scss'],
})
export class UserInfoComponent implements OnInit {
	user: AccountInfo;
	constructor(private authService: AuthService) { }

	get fullname() {
		return this.user ? this.user.name : null;
	}

	ngOnInit() {
		this.user = this.authService.msalUserInfo;
	}
	signOut(): void {
		this.authService.logout();
	}
}
